export const carImagesSourceList = {
  default: '/cars/default_bqz4dl.png',
  volvo: '/cars/volvo_ymjxzq.png',
  volkswagen: '/cars/volkswagen_lwplgv.png',
  skoda: '/cars/skoda_sqzsyb.png',
  vauxhall: '/cars/vauxhall_mlmfp8.png',
  smart: '/cars/smart_h0wkv8.png',
  tvr: '/cars/tvr_pektrn.png',
  toyota: '/cars/toyota_wnnb0i.png',
  suzuki: '/cars/suzuki_tvuref.png',
  seat: '/cars/seat_eiyyzf.png',
  tesla: '/cars/tesla_ajgqjx.png',
  subaru: '/cars/subaru_ngcxog.png',
  renault: '/cars/renault_ijktut.png',
  saab: '/cars/saab_ygnbwn.png',
  rover: '/cars/rover_wldysb.png',
  porsche: '/cars/porsche_prjxuj.png',
  nissan: '/cars/nissan_jqpch6.png',
  proton: '/cars/proton_qpe1ar.png',
  'rolls-royce': '/cars/rolls-royce_shzgxm.png',
  peugeot: '/cars/peugeot_vnnjgh.png',
  mitsubishi: '/cars/mitsubishi_fqqnme.png',
  mercedes: '/cars/mercedes_ncsxwh.png',
  mini: '/cars/mini_dnmk5p.png',
  morgan: '/cars/morgan_xatr7p.png',
  mazda: '/cars/mazda_geivjm.png',
  mg: '/cars/mg_fspoke.png',
  mclaren: '/cars/mclaren_ujmwul.png',
  landrover: '/cars/landrover_v1sjvi.png',
  lotus: '/cars/lotus_vzyywe.png',
  maserati: '/cars/maserati_nilkyj.png',
  jaguar: '/cars/jaguar_mivp9d.png',
  lexus: '/cars/lexus_opufvx.png',
  jeep: '/cars/jeep_hlctn3.png',
  lamborghini: '/cars/lamborghini_isuglz.png',
  hyundai: '/cars/hyundai_gmqiux.png',
  kia: '/cars/kia_xnvg61.png',
  honda: '/cars/honda_bsweiq.png',
  infiniti: '/cars/infiniti_vielo8.png',
  isuzu: '/cars/isuzu_nedtpz.png',
  ford: '/cars/ford_y1lbsq.png',
  ds: '/cars/ds_topusg.png',
  'great-wall': '/cars/great-wall_nien0m.png',
  ferrari: '/cars/ferrari_gmmepp.png',
  dacia: '/cars/dacia_vnahdt.png',
  dodge: '/cars/dodge_tewtcx.png',
  daewoo: '/cars/daewoo_xp8n1v.png',
  chrysler: '/cars/chrysler_evuyt8.png',
  citroen: '/cars/citroen_g5jhuo.png',
  bmw: '/cars/bmw_i4gi52.png',
  abarth: '/cars/abarth_epmjsp.png',
  'alfa-romeo': '/cars/alfa-romeo_kbhda2.png',
  'aston-martin': '/cars/aston-martin_gc9iv4.png',
  audi: '/cars/audi_kagyuw.png',
  austin: '/cars/austin_r6khl2.png',
  bentley: '/cars/bentley_llj4h8.png',
} as { [key: string]: string };
